import { type Experiment, type Toggle } from '@/lib/firebase/types'

/**
 * Converts a Toggle object to an Experiment object
 * Used to transform feature toggles into experiment contexts for A/B testing
 *
 * @param toggle - The Toggle object to convert
 * @returns An Experiment object or undefined if trackingKey is missing
 */
export const convertFromToggleToExperiment = (toggle?: Toggle): Experiment | undefined => {
  // Return undefined if the toggle or its tracking key is missing
  if (!toggle?.trackingKey) return undefined

  return {
    enabled: toggle.enabled,
    source: toggle.source,
    group: toggle.enabled ? 1 : 0,
    trackingKey: toggle.trackingKey,
  }
}
